module.exports = __webpack_public_path__ + "img/sort-up-alt.d3419d12.svg";